import { getSessionItem, setSessionItem, removeSessionItem } from './sessionStorage'
import { PostAnswerData } from '../models/global.types'

const CACHE_KEY = 'pending_module_answers'

interface CachedAnswers {
  sessionId: string
  attemptId: string
  answers: PostAnswerData[]
  timestamp: number
}

export function cacheAnswer (sessionId: string, attemptId: string, answer: PostAnswerData): void {
  const existing = getCachedAnswers()
  if (existing != null && existing.sessionId === sessionId) {
    existing.answers.push(answer)
    existing.timestamp = Date.now()
    setSessionItem(CACHE_KEY, existing)
  } else {
    setSessionItem(CACHE_KEY, { sessionId, attemptId, answers: [answer], timestamp: Date.now() })
  }
}

export function cacheAllAnswers (sessionId: string, attemptId: string, answers: PostAnswerData[]): void {
  setSessionItem(CACHE_KEY, { sessionId, attemptId, answers, timestamp: Date.now() })
}

export function getCachedAnswers (): CachedAnswers | null {
  return getSessionItem(CACHE_KEY) ?? null
}

export function clearCachedAnswers (): void {
  removeSessionItem(CACHE_KEY)
}
